import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import FooterV2 from './index';
import HiddenFooterContainer from './HiddenFooterContainer';

const FixedFooterContainer = styled.div`
  position: fixed;
  text-align: center;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  max-width: 100%;
  pointer-events: none;
`;

const StyledFooterV2 = styled(FooterV2)`
  display: inline-block;
  pointer-events: all;
`;

const FloatingFooter = ({ className, hashState }: { className?: string; hashState?: string }) => {
  const { featuresToggle } = useSelector((s) => s.eventConfigs);

  if (featuresToggle.removeFooter) return null;

  return (
    <>
      <HiddenFooterContainer className={className}>
        <FooterV2 hashState={hashState} />
      </HiddenFooterContainer>
      <FixedFooterContainer>
        <StyledFooterV2 hashState={hashState} />
      </FixedFooterContainer>
    </>
  );
};

export default FloatingFooter;
